export interface NotifyPortalMessage {
    messageType: MessageType,
    messageStatus: MessageStatus,
    customData: string | null
}

export enum MessageType {
    TRAJECTORY_OPTIMIZATION_FAILED = 0,
    TRAJECTORY_OPTIMIZATION_COMPLETED = 1,
    ORGANIZATION_PROVISIONING_COMPLETED = 2,
    ORGANIZATION_PROVISIONING_FAILED = 3,
}

//The names of this Enum directly map to the lowercase types in naive-ui
export enum MessageStatus {
    success = 0,
    warning = 1,
    error = 2,
}
